import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/do'
import { authenticate } from '../api/Authenticate'
import { LoginTypes } from './loginRedux'
import { ServiceTypes } from './serviceRedux'
import { REDIRECT_URI } from '../config/constants'
import { makeGetServiceAuthorized } from '../selectors/serviceAuthorizationSelector'

const getServiceAuthorized = makeGetServiceAuthorized()

const AUTHENTICATE = LoginTypes.AUTHENTICATE
const LOGIN_REQUESTED = LoginTypes.LOGIN_REQUESTED
const LOGIN_FETCHING = LoginTypes.LOGIN_FETCHING
const LOGIN_FULFILLED = LoginTypes.LOGIN_FULFILLED
const LOGOUT = LoginTypes.LOGOUT
const SERVICE_CARD_CHANGED = ServiceTypes.SERVICE_CARD_CHANGED

const loginFetching = () => ({ type: LOGIN_FETCHING })
const logoutFulfilled = () => ({ type: 'LOGOUT_FULFILLED' })

export const loginEpic = (action$, store) =>
  action$
  .ofType(LOGIN_REQUESTED)
  .do(() => console.log('authenticating'))
    .do(action => {
      authenticate.login()
    })
    .map(action => loginFetching())

export const logoutEpic = action$ =>
  action$
    .ofType(LOGOUT)
    .do(() =>
      window.location.replace(
        `https://coresight.auth0.com/v2/logout?returnTo=${encodeURIComponent(
          REDIRECT_URI
        )}`
      )
    )
    .map(() => logoutFulfilled())

export const loginFulfilledEpic = (action$, store) =>
  action$
  .ofType(LOGIN_FULFILLED, AUTHENTICATE)
  .map(() => {
    const state = store.getState()
    const authorizedServices = getServiceAuthorized(store.getState())
    const currentService = state.service.serviceCardActive
    const action = authorizedServices.find(service => service.name === currentService.name) || !authorizedServices[0]
      ? { type: 'EMPTY' }
      : { type: SERVICE_CARD_CHANGED, service: authorizedServices[0] }
    return action
  })



// WEBPACK FOOTER //
// ./src/redux/loginEpic.js